<template>
  <Elegibilidade/>
</template>

<script>

import Elegibilidade from '@/views/141/Elegibilidade'

export default {
  name: 'Func141',
  components: { Elegibilidade }
}
</script>

<style>
</style>
